import { styled } from '@mui/material';

import { fontSize } from '@verantos-dev/shared-ui-components/tokens';

export const StyledColumnHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  overflow: 'hidden',
  padding: theme.spacing(4, 6),
  fontWeight: 500,
  color: theme.palette.text.primary,
  '&:hover .column-header-icon': {
    transform: 'translateX(6px)',
    transition: 'transform 0.2s cubic-bezier(0.4,0,0.2,1)',
  },
}));

export const StyledHeaderText = styled('div')(({ theme }) => ({
  whiteSpace: 'nowrap',
  fontSize: fontSize[14],
  textOverflow: 'ellipsis',
  marginRight: theme.spacing(2),
}));

export const StyledColumnHeaderIcon = styled('div')({
  display: 'flex',
  alignItems: 'center',
  transition: 'transform 0.2s cubic-bezier(0.4,0,0.2,1)',
});
